import { localApi } from '../../shared/config/axiosConfig';
/**
 *
 * @returns
 */
export const getFileApi = (file, isGIMtransfer) => {
  let params = isGIMtransfer ? '&isGIMtransfer=true' : '';
  return localApi({
    method: 'GET',
    url: `/FileView?FileName=${file}${params}`,
  });
};

/**
 *
 * @returns
 */
export const getFileContentApi = (file, isGIMtransfer) => {
  let params = isGIMtransfer ? '&isGIMtransfer=true' : '';
  return localApi({
    method: 'GET',
    url: `/FileView?FileName=${file}${params}`,
    params,
  });
};

/**
 *
 * @returns
 */
export const ReadAndAddObjects = async (data) => {
  const response = await localApi({
    method: 'POST',
    url: 'ReadFileOld',
    data,
  });
  return response.data;
};

/**
 * Applies transformation to an object in pro/store environment
 * @param {import('global').UpdateObjectTransformRequest} data data
 * @returns
 */
export const UpdateObjectTransformHub = async (data) => {
  const response = await localApi({
    method: 'POST',
    url: 'ReadFileOld',
    data,
  });
  return response.data;
};

/**
 * Used to request the conversion of a file to a simple glb to place on gimmaps.
 * @param {number} ProjectId Project Id
 * @param {number} ObjectId Object Id
 * @param {boolean} forGimMap whether this GLB is for the GIMmap or not
 * @returns {Promise<string>} GLB string of the object
 */
export const getFileGlb = async (ProjectId, ObjectId, forGimMap = true) => {
  const response = await localApi({
    method: 'POST',
    url: '/GetFileGlb',
    data: { ProjectId, ObjectId },
    params: { forGimMap },
  });
  return await response.data;
};

/**
 * Gets a file's Json From the GIMmanager (with caching).
 * @param {string} guid The file's GUID
 * @param {(progress: number) => any} onProgress function to monitor progress (optional)
 * @param {AbortSignal} abortSignal fetch abort signal (option)
 * @returns {Promise<import('../webAPI/webApi.file.service').ObjectJSON_1_1_2>}
 */
export const GetFileJsonFromHub = async (
  guid,
  onProgress = null,
  abortSignal
) => {
  const filename = guid + '.json';

  const response = await localApi({
    method: 'GET',
    url: '/FileView',
    params: {
      FileName: filename,
    },
    signal: abortSignal,
    onDownloadProgress: onProgress
      ? (progressEvent) => {
          const total = progressEvent.total;
          const loaded = progressEvent.loaded ?? 0;
          if (!total || !Number.isFinite(total) || total <= 0) return;
          const transfer = Math.min(1, Math.max(0, loaded / total));
          onProgress(0.7 + transfer * 0.3);
        }
      : null,
  });
  return response.data;
};

/**
 * @param {number} objectID object ID
 * @param {number} projectID project ID
 * @param {number | null} subProjectID subproject ID
 * @param {string} name object name
 * @param {import('../webAPI/webApi.file.service').ObjectJSON_1_1_2} finalModel
 * @returns {Promise<any>}
 */
export const UpdateObjectChildren = async (
  objectID,
  projectID,
  name,
  finalModel,
  subProjectID = null
) => {
  const data = {
    ObjectID: objectID,
    ProjectID: projectID,
    SubProjectID: subProjectID,
    ObjectName: name,

    JsonContent: JSON.stringify(finalModel, null, 2),
  };
  const response = await localApi({
    method: 'POST',
    url: '/UpdateObjectChildren',
    data: data,
  });

  return response.data;
};
